// Open and close listener
rm_toggle = (function() {
    // define class and attributes
    const collapsible_container = "[rm-collapsible]";
    const drawer_overlay = ".rm-sizing-guide__overlay";
    const attribute_identifier = 'id';
    

    let overlays = document.querySelectorAll(drawer_overlay)
    let rm_collapsible = document.querySelectorAll(collapsible_container);
    rm_collapsible.forEach(function(collapsible, index) {
        if (collapsible.getAttribute('id') == "rm-send-hint") {
            document.body.appendChild(collapsible)
        }
        
        let id = collapsible.getAttribute(attribute_identifier);
        let open_button = document.querySelector(`[data-action="open"][data-target-id="${id}"]`);
        let close_button = document.querySelector(`[data-action="close"][data-target-id="${id}"]`);
        if (open_button != undefined) {
            let sibling_class = open_button.getAttribute('data-sibling-class');
            let sibling_triggers = document.querySelectorAll(`.${sibling_class}`);
            
            open_button.addEventListener('click', function(event) {
                console.log(sibling_triggers);
                sibling_triggers.forEach(function(element, index) {
                    if (element != open_button) {
                        let target = document.querySelector(`#${element.getAttribute('data-target-id')}`);
                        target.setAttribute('aria-hidden', true);
                        element.setAttribute('aria-expanded', false);
                    }
                });
                collapsible.setAttribute('aria-hidden',  false);
                event.target.setAttribute('aria-expanded', true);
                document.querySelector('html').classList.add('rm-sizing-guide__modal--open');
            });
            if (close_button != undefined) {
                close_button.addEventListener('click', function(event) {
                    collapsible.setAttribute('aria-hidden', true);
                    open_button.setAttribute('aria-expanded', false);
                    document.querySelector('html').classList.remove('rm-sizing-guide__modal--open');
                })
            }
        }
    })
    if (overlays != undefined) {
        overlays.forEach((overlay) => {
            overlay.addEventListener('click', function(event) {
                let modals = document.querySelectorAll('[collapsible_type="popup"]');
                let open_button = document.querySelectorAll(`[data-action="open"][data-target-id]`);
                modals.forEach((modal)=> {
                    modal.setAttribute('aria-hidden', true);
                });
                open_button.forEach((button)=> {
                    button.setAttribute('aria-expanded', false);
                })
                document.querySelector('html').classList.remove('rm-sizing-guide__modal--open');
             })
        })
    }

})();

rm_calc = (function() {
    // Get Data
    let calculator = document.querySelector('.rm-sizing-guide__calculator')
    let table_container = document.querySelector('#rm-chart-in');
    if (table_container != undefined) {
        var sizes = table_container.querySelectorAll('tr');
        var size_data = initializeData(sizes);
        var input_elements = document.querySelectorAll('[data-calc-input]');
        var results_el = calculator.querySelector('.rm-sizing-guide__result');
        var recommended_text = calculator.getAttribute('recommended');
        var non_match_text = calculator.getAttribute('non-match');
        var trigger = document.querySelector('.rm-sizing-guide__trigger')
        var calc_type = calculator.getAttribute('calculator');
    
        initInputs(input_elements);
    }


    function initializeData(sizes) {
        let size_data = [];
        sizes.forEach(function(element, index) {
            let values = element.querySelectorAll('td');
            let size_values = [];
            values.forEach(function(el, i) {
                // size result
                if (i == 0) {
                    size_values.push(el.textContent);
                } else {
                    let value = el.textContent.split('-');
                    let range = []
                    let min = value[0];
                    let max = value[1];
                    range.push(min);
                    range.push(max);
                    size_values.push(range);
                }
            });
            size_data.push(size_values);
        });
        return size_data
    }
    function initInputs(input_elements) {
        let input_names = [];
        // Init listener and calc
        input_elements.forEach(function(input, index) {
            let in_name = input.getAttribute('name');
            input_names.push(in_name)
            input.addEventListener('input', function(event) {
                let input_name = event.target.getAttribute('name');
                let unit =  event.target.getAttribute('data-unit');
                let input_value = Number.parseFloat(event.target.value).toFixed(1);
                let similar_inputs = calculator.querySelectorAll(`[name="${input_name}"]`);
                let sibling_inputs = calculator.querySelectorAll(`[data-unit="${unit}"]`);
                let sibling_inputs_count = sibling_inputs.length;
                let input_count = 0;
                let inputs = [];

                // update other inputs
                conversion(similar_inputs, unit, event.target, input_value);

                // check if all input has value then calculate
                sibling_inputs.forEach(function(el, i) {
                    if (el.value > 0 ) {
                        inputs.push(el.value);
                        input_count = input_count + 1;
                    }
                });
                if (input_count == sibling_inputs_count) {
                    let size_result = calculateSize(inputs, unit);
                    if (size_result == "NA") {
                        results_el.innerHTML = non_match_text;
                        
                    } else {
                        let trimmed_size_result = size_result.toString().trim().replace(/(\r\n|\n|\r)/gm, "");
                        results_el.innerHTML = '<span>' + recommended_text + '</span>' + size_result;
                        trigger.querySelector('span').textContent = trigger.getAttribute('recommended').replace('size_result', trimmed_size_result);
                        // set cookie
                        console.log("set Cookie");
                        console.log(trimmed_size_result)
                        setCookie("size_result", trimmed_size_result, 31);
                        setCookie("size_unit", unit, 31);
                        for (let c = 0; c  < inputs.length; c++) {
                            setCookie(input_names[c], inputs[c], 31);
                        }
                    }
                    results_el.setAttribute('aria-hidden', false);
                } else {
                    results_el.setAttribute('aria-hidden', true);
                }
            });
        });

        // check and display cookie
        let cookie_results = getCookie('size_result');
        if (cookie_results != undefined && cookie_results != '') {
            let cookie_unit = getCookie('size_unit');
            let cooke_inputs = [];

            for (let c = 0; c < input_names.length; c++) {
                let input_elem = calculator.querySelector(`[data-unit="${cookie_unit}"][name="${input_names[c]}"]`);
                let other_inputs = calculator.querySelectorAll(`[name="${input_names[c]}"]`);
                input_elem.value = getCookie(input_names[c]);
                conversion(other_inputs, cookie_unit, input_elem, getCookie(input_names[c]));
                calculator.querySelector(`[data-unit="${cookie_unit}"][name="${input_names[c]}"]`).dispatchEvent(new CustomEvent('input', {
                    bubbles: true
                }));
                // cooke_inputs.push(getCookie(input_names[c] + calc_type));
            }
        }
    }

    function conversion(similar_inputs, unit, changed_element, input_value) {
        console.log("Convert")
        similar_inputs.forEach(function(el, i) {
            // only allow 1 decimal places, not rounded
            if (el != changed_element) {
                // 1 in = 2.5cm
                if (unit == 'in') {
                    el.value = Number.parseFloat(input_value * 2.5).toFixed(1);
                } else {
                    el.value = Number.parseFloat(input_value / 2.5).toFixed(1);
                }
            }  else {
                // make sure input is 1 decimal place
                let string_value = 0;
                if (input_value.toString().includes('.')) {
                    string_value = input_value.toString().split('.')[1].length || 0;
                }
                
                if (string_value > 2) {
                    changed_element.value = input_value;
                }
            }
        });
    }
    function calculateSize(inputs, unit) {
        let size_result = "NA";
        for (let i = 0; i < size_data.length; i++) {
            let match_count = 0
            let column_count = size_data[i].length - 1;
            for (let v = 1; v < size_data[i].length; v++) {
                let min = size_data[i][v][0];
                let max = size_data[i][v][1];
                if (unit == "cm") {
                    min = min * 2.5;
                    max = max * 2.5
                }
                if (inputs[v - 1] >= min && inputs[v - 1] <= max) {
                    match_count = match_count  + 1;
                }
            }
            if  (match_count == column_count) {
                size_result = size_data[i][0];
                break
            }
        }
        return size_result
    }
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000)); //exdays*60*1000 if minutes
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
})();


console.log('RM SCRIPTS LOADED')
document.addEventListener('DOMContentLoaded', function() {
    let collectionLinks = document.querySelectorAll("a");
    collectionLinks.forEach((link) => {
        let url = link.getAttribute("href");
        if (url.includes("/collections")) {
            if (url.includes("?")) {
                link.setAttribute("href", url + "&filter.v.availability=1");
            } else {
                link.setAttribute("href", url + "?filter.v.availability=1");
            }
        }
    })
    let megamenuLinks = document.querySelectorAll("[data-follow-link]");
    megamenuLinks.forEach((link) => {
        let url = link.getAttribute("data-follow-link");
        if (url.includes("/collections")) {
            if (url.includes("?")) {
                link.setAttribute("data-follow-link", url + "&filter.v.availability=1");
            } else {
                link.setAttribute("data-follow-link", url + "?filter.v.availability=1");
            }
        }
    })
});